var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"area-select"},[_c('el-cascader',{style:({width: _vm.width}),attrs:{"options":_vm.options},model:{value:(_vm.areaValue),callback:function ($$v) {_vm.areaValue=$$v},expression:"areaValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }